import type {
  ReferencedBrand,
  ReferencedBrandCategory,
  ReferencedBrandPoi,
  ReferencedBrandsStats,
} from '@gozoki/api-types'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { triggerReferencedBrandsScrape } from '../mutations/referencedBrands.mutations'
import {
  fetchReferencedBrandCategories,
  fetchReferencedBrandPois,
  fetchReferencedBrands,
  fetchReferencedBrandsStats,
} from '../queries/referencedBrands.queries'

const KEYS = {
  categories: ['referenced-brand-categories'] as const,
  brands: ['referenced-brands'] as const,
  pois: ['referenced-brand-pois'] as const,
  stats: ['referenced-brands', 'stats'] as const,
}

export const useReferencedBrandCategories = () =>
  useQuery<ReferencedBrandCategory[]>({
    queryKey: KEYS.categories,
    queryFn: fetchReferencedBrandCategories,
  })

export const useReferencedBrands = () =>
  useQuery<ReferencedBrand[]>({
    queryKey: KEYS.brands,
    queryFn: fetchReferencedBrands,
  })

export const useReferencedBrandPois = () =>
  useQuery<ReferencedBrandPoi[]>({
    queryKey: KEYS.pois,
    queryFn: fetchReferencedBrandPois,
  })

export const useReferencedBrandsStats = () =>
  useQuery<ReferencedBrandsStats>({
    queryKey: KEYS.stats,
    queryFn: fetchReferencedBrandsStats,
  })

export const useTriggerReferencedBrandsScrape = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => triggerReferencedBrandsScrape(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEYS.pois })
      qc.invalidateQueries({ queryKey: KEYS.stats })
      qc.invalidateQueries({ queryKey: KEYS.brands })
    },
  })
}
